import { Capacitor } from '@capacitor/core';
import { IonAlert, IonButton, IonIcon, IonItem, IonLabel, IonList, IonRadio, IonRadioGroup, isPlatform } from '@ionic/react';
import React from 'react';
import { connect } from 'react-redux';
import { getConfig } from '../../appConfig';
import { NormalText, Spacer, StrongText, Title } from '../../components/common';
import Layout from '../../components/layout';
import Mobiscroll from '../../components/mobiscroll';
import Modal from '../../components/modal';
import Loading from '../../components/spinner';
import Basket from '../../lib/basket';
import moment from '../../lib/moment';
import LibStripe from '../../lib/stripe';
import { withTranslation } from '../../lib/translate';
import { forwardTo, goBack, isDefined, isWebConfig, sendToAnalytics, formatBasketItemForAnalytics, getAnalyticsCurrency, roundAnalyticsMoney } from '../../lib/utils';
import { getRestaurants, logout, setCommonModal } from '../../store/actions';
import { checkSnoozedTimes, formatDataForTime } from '../clickAndCollect';
import CheckoutPay from './CheckoutPay';
import './index.css';
import 'moment-timezone';
import { ReactComponent as CardDefault } from '../../assets/images/card-default.svg';
import SquarePayButtons from '../../components/squarePayButtons';
import CheckoutPayButtons from '../../components/checkoutPayButtons';

const { SelectOption } = Mobiscroll;
const { getMobile, setMobile, getOrderType, _getTotal, shouldAddPrepTime } = Basket;
const isWeb = () => Capacitor.getPlatform() === 'web';

class Checkout extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedCard: null,
			collectedModal: false,
			driverModal: false,
			pickTime: null,
		};
	}
	goToPreviousPage() {
		if (Basket.bill_data.pay_method == '0') {
			forwardTo('/table-overview');
		} else if (Basket.bill_data.pay_method == '1') {
			forwardTo('/split-bill');
		} else if (Basket.bill_data.pay_method == '2') {
			forwardTo('/split-bill-by-amount');
		} else if (Basket.bill_data.pay_method == '3') {
			forwardTo('/split-bill-by-items');
		}
	}
	componentDidMount() {
		this.props.dispatch(getRestaurants({ skipLoading: true }));
		const { profile, cards } = this.props;
		const { google } = window
		window.googlePayClient = new google.payments.api.PaymentsClient({ environment: 'PRODUCTION' })
		try {
			const cartItems = Basket.getAllItems();
			const cartValue = cartItems.reduce((sum, basketItem) => sum + ((parseFloat(basketItem.item?.productPrice) || 0) * (basketItem.quantity || 1)), 0);
			sendToAnalytics('begin_checkout', {
				ecommerce: {
					currency: getAnalyticsCurrency(),
					value: roundAnalyticsMoney(cartValue),
					items: cartItems.map((basketItem) => formatBasketItemForAnalytics(basketItem)),
				},
			});
		} catch (e) { console.log('Error_sending_begin_checkout_analytics', e); }
		if (!getConfig().flags.paymentDisabled) {
			if (profile.cardToken) {
				this.changeSelectedPaymentCard(profile.cardToken);
			}
			cards.length == 0 && isWeb() && profile.is_guest &&
				!this.props?.location?.state?.cardAdded &&
				!getConfig()?.squarePayment?.enabled &&
				!getConfig()?.checkoutPayment?.enabled &&
				forwardTo('/card-add', {
					addCardFromCheckout: true,
					title: 'Checkout',
					giftVoucher: this.props?.location?.state?.giftVoucher,
					fromTablePay: this.props?.location?.state?.fromTablePay,
				});
		}

	}

	componentDidUpdate(prevProps) {
		if (prevProps.profile.cardToken !== this.props.profile.cardToken) {
			this.changeSelectedPaymentCard(this.props.profile.cardToken);
		}
		// reset the picked time each time the modal opens so the first available slot is auto-selected again
		if (!prevProps.deliveryTimeModalOpen && this.props.deliveryTimeModalOpen && this.state.pickTime) {
			this.setState({ pickTime: null });
		}
	}

	drawPayButton = () => {
		const { __ } = this.props;
		let ret = null;
		if (LibStripe.getStripeInstance() && Capacitor.getPlatform() !== 'web') {
			if (!isPlatform('ios')) {
				//android
				ret = (
					<IonButton className='button-uppercase' expand="block" color="primary" disabled={this.props.loading > 0} onClick={() => {
						const uuid = `${this.props.profile.id}_${Date.now()}`;
						Basket.setUUID(uuid);
						Basket.createOrder('google');
					}}>
						{__('Google Pay')}
					</IonButton>
				);
			} else {
				//ios
				ret = (
					<IonButton className='button-uppercase' expand="block" color="primary" disabled={this.props.loading > 0} onClick={() => {
						const uuid = `${this.props.profile.id}_${Date.now()}`;
						Basket.setUUID(uuid);
						Basket.createOrder('apple');
					}}>
						{__('Apple Pay')}
					</IonButton>
				);
			}
		}
		return ret;
	};

	changeSelectedPaymentCard = (cardId) => {
		this.setState({ selectedCard: cardId }, () => {
			Basket.changeSelectedCard(cardId);
		});
	}


	backHandler = () => {
		if (this.props.location && this.props.location.state && this.props.location.state.skipContactDetails) {
			forwardTo('/order-summary', { skipBackToThePreviousPage: true });
		} else if (Basket.isEvent()) {
			forwardTo('/event-checkout');
		} else if (this.props?.location?.state?.giftVoucher) {
			forwardTo('/gift-voucher', { voucher: this.props?.location?.state?.giftVoucher, hasEdit: true, redirectedFromCheckout: true });
		} else if (this.props.location?.state?.fromTablePay) {
			goBack();
		} else if (this.props.location.pathname === '/checkout') {
			forwardTo('/order-summary');
		} else {
			goBack();
		}
	};

	showCollectedModal = (modalOpen) => {
		this.setState({ collectedModal: modalOpen });
	};

	showDriverModal = (modalOpen) => {
		this.setState({ driverModal: modalOpen });
	};

	changeTime = (selectedTime, minDT) => {
		let h = parseInt(selectedTime.split(':')[0]);
		let m = parseInt(selectedTime.split(':')[1]);
		const formattedDT = moment(minDT).hours(h).minutes(m);
		Basket.setCollectionTime(formattedDT);
	};

	setPickTime = (inst, minDT) => {
		if (inst.getVal()) {
			this.changeTime(inst.getVal(), minDT);
			this.setState({ pickTime: inst.getVal() });
		}
	};

	createSquareOrder = (paymentData) => {
		const uuid = `${this.props.profile.id}_${Date.now()}`;
		Basket.setUUID(uuid);
		Basket.createSquareOrder(paymentData);
	};

	createCheckoutPaymentOrder = (paymentData) => {
		const uuid = `${this.props.profile.id}_${Date.now()}`;
		Basket.setUUID(uuid);
		Basket.createCheckoutPaymentOrder(paymentData);
	};

	render() {

		const { __, cards, clientSecret, dispatch, location, profile, deliveryTimeModalOpen, restaurants } = this.props;
		const { collectedModal, driverModal, pickTime } = this.state;
		let orderType = '';
		let price = '';
		let store = '';
		let snoozedTimes = '';
		let minDT = '';
		let timePickerOptions = [];
		const { payments } = getConfig()?.services;
		const deliveryOptionId = Basket.getDeliveryOption()?.id;
		const payOrderOnCollection = getConfig().flags.showAllPaymentMethodsOnCheckout && ((getConfig().flags.payTableOrderOnCollection && deliveryOptionId == 'table') || (getConfig().flags.payCollectionOrderOnCollection && (deliveryOptionId == 'collection' || deliveryOptionId == 'scheduled-collection')) || (getConfig().flags.payCounterOrderOnCollection && deliveryOptionId == 'pick-up-at-counter'));
		const { webPay } = payments;
		// event tickets have no collection time, order type or menu, same as vouchers
		if (Basket.getDeliveryOption()?.id !== 'gift-vouchers' && Basket.getDeliveryOption()?.id !== 'events') {
			orderType = getOrderType();
			price = _getTotal();
			store = restaurants.find((restaurant) => restaurant.id === Basket.getRestaurant()?.id);
			if (orderType === 'Table') {
				snoozedTimes = [];
			} else {
				snoozedTimes = checkSnoozedTimes(store, Basket.order_type); // TODO Update
			}
			minDT = moment();
			if (Basket.getDeliveryOption()?.id === 'charter-delivery') {
				if (store && isDefined(store.charter_delivery_order_slot_lead_time) && shouldAddPrepTime()) {
					minDT.add(store.charter_delivery_order_slot_lead_time, 'minutes');
				}
			} else {
				if (store && isDefined(store.order_slot_lead_time) && shouldAddPrepTime()) {
					minDT.add(store.order_slot_lead_time, 'minutes');
				}
			}

			timePickerOptions = formatDataForTime(Basket.getRestaurant(), minDT, Basket.getRestaurant()?.id, Basket.getDeliveryOption()?.id === 'charter-delivery' ? true : false, false, snoozedTimes);
		} else {
			if (!Basket.is_gift && this.props?.location?.state?.giftVoucher) {
				Basket.setCollectionTime(null);
				Basket.setGift(this.props.location.state.giftVoucher);

				Basket.addToBasket({
					item: {
						productPrice: this.props?.location?.state?.giftVoucher.points_value / 100,
						productName: 'Voucher',
					},
					quantity: 1,
					is_gift: true

				});
				Basket.setRestaurant(restaurants.find((restaurant) => restaurant.name === 'Vouchers'));
			}
		}
		const giftcardLocationId = getConfig()?.squarePayment?.giftcardLocationId;
		const squareRestaurant = deliveryOptionId === 'gift-vouchers' && giftcardLocationId ? { ...Basket.getRestaurant(), business_location_id: giftcardLocationId } : store;
		return (
			<>
				<Loading transparent>
					<Layout color="transparent" headerWithTitle={true} title={getConfig()?.squarePayment?.enabled || getConfig()?.checkoutPayment?.enabled  ? __('Select payment method') : __('Checkout')} backHandler={this.backHandler}>
						<div className="flex-row-wrapper absolute-content box-with-shadow">
							<Title className="web-only page-title-centered">{__('Checkout')}</Title>
							{/* <SmallText>{__('Use saved payment card')}</SmallText> */}
							{getConfig()?.squarePayment?.enabled || getConfig()?.checkoutPayment?.enabled ?
								getConfig()?.checkoutPayment?.enabled ?
									<CheckoutPayButtons
										__={__}
										createOrderCb={this.createCheckoutPaymentOrder}
										autoSaveCard={true}
										restaurant={store}
										hideGooglePay={this.props?.profile?.is_guest ? false : true}
										hideApplePay={this.props?.profile?.is_guest ? false : true}
									/>
									:
									<SquarePayButtons
										__={__}
										createOrderCb={this.createSquareOrder}
										autoSaveCard={true}
										restaurant={squareRestaurant}
										hideGooglePay={false}
										hideApplePay={false}
									/>
								: <>
									{isWeb() ?
										<>
											<div className="scrollable-y box-with-shadow">
												{!getConfig().flags.paymentDisabled &&
													<>
														<IonList lines="none" >
															<IonRadioGroup value={this.state.selectedCard}>
																{cards.map((card) => {
																	const { id, last4, brand, exp_month, exp_year, name } = card;

																	return (
																		<IonItem lines="none" className="box-content checkout-card cards-list-card " key={id}>
																			<div className="card-icon-wrapper">
																				<CardDefault />

																			</div>

																			<IonLabel className="ion-text-wrap" onClick={(e) => this.changeSelectedPaymentCard(id)}>
																				<StrongText >{__(brand)} - {exp_month}/{exp_year}</StrongText>
																				<Spacer size={0} />
																				<StrongText className=" block">**** **** **** {last4}</StrongText>

																			</IonLabel>
																			<IonRadio
																				color='primary'
																				slot="start"
																				value={id}
																				onIonSelect={() => {
																					this.setState({ selectedCard: id }, () => {
																						Basket.changeSelectedCard(id);
																					});
																				}}
																			/>
																		</IonItem>
																	);
																})}
															</IonRadioGroup>
														</IonList>
														<IonButton

															color="secondary"
															className="link"
															onClick={() =>
																forwardTo('/card-add', {
																	addCardFromCheckout: true,
																	giftVoucher: this.props.giftVoucher ? this.props.giftVoucher : this.props?.location?.state?.giftVoucher ? this.props?.location?.state?.giftVoucher : false,
																	fromTablePay: this.props?.location?.state?.fromTablePay,
																})
															}
														>
															{__('Add payment card')}
														</IonButton>
													</>
												}
											</div>
											<Spacer size={5} />
											<div className="flex-min">
												{!getConfig().flags.paymentDisabled &&
													<>
														<IonButton
															disabled={cards.length === 0 || !this.state.selectedCard || this.props.loading > 0}
															className="button-uppercase"
															onClick={() => {
																const uuid = `${this.props.profile.id}_${Date.now()}`;
																Basket.setUUID(uuid);
																Basket.setSelectedCard(this.state.selectedCard);
																!this.props.location?.state?.fromTablePay ? Basket.createOrder() : Basket.createBillPay();
															}}
															expand="block"
														>
															{__('Pay')}
														</IonButton>
														<Spacer size={2} />
													</>}
												{getConfig().flags.hasYocoPayment && Basket.isGift() ? (
													<>

														<IonButton
															style={{ marginBottom: '10px' }}
															className="button-uppercase"
															onClick={() => {
																Basket.createYocoOrder('yoco');
															}}
															expand="block"
														>
															{__('Pay With Yoco')}
														</IonButton>
														<Spacer size={2} />
													</>
												) : null}


												{getConfig().flags.paymentDisabled && getConfig().flags.payTheDriver && orderType === 'Delivery' ? (
													<>
														<IonButton className='button-uppercase' onClick={() => Basket.createOrder('driverPay')} expand="block" color="primary">
															{`${__('Pay')} ${price} ${__('To The Driver')}`}
														</IonButton>
														<Spacer size={2} />
													</>
												) : null}
												{!this.props?.location?.state?.fromTablePay && (
													<>
														{getConfig().prebuildPayment?.isVisible ? (
															<>
																<IonButton
																	style={{ marginBottom: '10px' }}
																	className="button-uppercase"
																	onClick={() => {
																		Basket.createPrebuildPaymentOrder(getConfig().prebuildPayment?.label);
																	}}
																	expand="block"
																>
																	{__(getConfig().prebuildPayment?.label)}
																</IonButton>
																<Spacer size={2} />
															</>

														) : null}

													</>
												)}
												{!getConfig().flags.paymentDisabled &&
													<CheckoutPay
														isBillPay={this.props?.location?.state?.fromTablePay ? true : false}
														clientSecret={clientSecret}
														dispatch={dispatch}
														__={__}
														location={location}
														profile={profile}
													/>}

												{payOrderOnCollection || (getConfig().flags.paymentDisabled && ((getConfig().flags.payOnCollection && (Basket.getDeliveryOption()?.id == 'scheduled-collection' || Basket.getDeliveryOption()?.id == 'collection')) || (getConfig().flags.payTableOnCollection && Basket.getDeliveryOption()?.id == 'table') || (getConfig().flags.payCounterOnCollection && Basket.getDeliveryOption()?.id == 'pick-up-at-counter'))) ? (
													<>
														<IonButton className='button-uppercase' onClick={() => Basket.createOrder('collectedPay')} expand="block" color="primary">
															{`${__('Pay')} ${price} ${__('On Collection')}`}
														</IonButton>
														<Spacer size={2} />
													</>
												) : null}
											</div>
										</>
										: null
									}
									{!isWeb() ? (
										<>
											{getConfig()?.prebuildPayment?.showOnNative ? (
												<>
													<IonButton
														style={{ marginBottom: '10px' }}
														className="button-uppercase"
														disabled={this.props.loading > 0}
														onClick={() => {
															const uuid = `${this.props.profile.id}_${Date.now()}`;
															Basket.setUUID(uuid);
															Basket.createPrebuildPaymentOrder(getConfig().prebuildPayment?.label);
														}}
														expand="block"
													>
														{__(getConfig().prebuildPayment?.label)}
													</IonButton>
													<Spacer size={2} />

												</>

											) : null}
											{!isWeb() && getConfig().nativePayment?.isVisible ? (
												<>
													<IonButton
														style={{ marginBottom: '10px' }}
														className="button-uppercase"
														disabled={this.props.loading > 0}
														onClick={() => {
															const uuid = `${this.props.profile.id}_${Date.now()}`;
															Basket.setUUID(uuid);
															Basket.createOrder('NativePayment');
														}}
														expand="block"
													>
														{__(getConfig().nativePayment?.label)}
													</IonButton>
													<Spacer size={2} />
												</>
											) : null}
											{getConfig().flags.hasYocoPayment ? (
												<>

													<IonButton
														style={{ marginBottom: '10px' }}
														className="button-uppercase"
														onClick={() => {
															Basket.createYocoOrder('yoco');
														}}
														expand="block"
													>
														{__('Pay With Yoco')}
													</IonButton>
													<Spacer size={2} />
												</>
											) : null}
										</>) : null
									}
								</>}
							{this.props.profile.is_guest && (
								<>
									<Spacer size={2} />
									<IonButton
										expand="block"
										className='button-uppercase'
										onClick={() => {
											const giftVoucher = this.props?.location?.state?.giftVoucher || (Basket.getDeliveryOption()?.id === 'gift-vouchers' && this.props.giftVoucherData);
											if (giftVoucher) {
												forwardTo('/gift-voucher', { voucher: giftVoucher, hasEdit: true, redirectedFromCheckout: true });
											} else {
												this.props?.location?.state?.fromTablePay ? this.goToPreviousPage() : forwardTo('/order-summary');
											}
										}}
									>
										{__('Cancel')}
									</IonButton>
								</>

							)}
						</div>
					</Layout>
					<IonAlert
						isOpen={collectedModal}
						onDidDismiss={() => this.showCollectedModal(false)}
						header={__('Pay on Collection')}
						message={__('You agree to pay the amount shown before collecting your order. Earned loyalty will be updated after payment.')}
						buttons={[
							{
								text: __('Confirm'),
								cssClass: 'primary',

								handler: () => {
									Basket.createOrder('collectedPay');
									this.showCollectedModal(false);
								},
							},
							{
								text: __('Cancel'),
								role: 'cancel',
								cssClass: 'secondary link',
								handler: () => this.showCollectedModal(false),
							},

						]}
					/>
					<IonAlert
						isOpen={driverModal}
						onDidDismiss={() => this.showDriverModal(false)}
						header={__('Pay to the Driver')}
						message={__('You agree to pay the driver the amount outstanding on delivery. Earned loyalty will be updated  after payment.')}
						buttons={[
							{
								text: __('Cancel'),
								role: 'cancel',
								cssClass: 'secondary link',
								handler: () => this.showDriverModal(false),
							},
							{
								text: __('Confirm'),
								cssClass: 'primary',

								handler: () => {
									Basket.createOrder('driverPay');
									this.showDriverModal(false);
								},
							},
						]}
					/>
				</Loading>
				<Modal className="delivery-time-modal" isOpen={deliveryTimeModalOpen} onDidDismiss={() => dispatch(setCommonModal('deliveryTimeModalOpen', false))}>
					<Title className='modal-title'>{__('Select Collection Time')}</Title>
					<NormalText>{__('Please select different time')}</NormalText>
					<Spacer />
					<SelectOption
						theme='ios'
						cssClass={isWebConfig() ? 'web' : ''}

						display="inline"
						onSet={(e, inst) => this.setPickTime(inst, minDT)}
						data={timePickerOptions}
						label="Location"
						value={pickTime}
						inputStyle="box"
						placeholder={__('Select Collection Time')}
						setText={__('OK')}
						cancelText={__('Cancel')}
						onInit={() => {
							// onInit re-fires on every re-render (mobiscroll re-inits when props change),
							// so persist the auto-picked time in state, otherwise changeTime -> basket update
							// -> re-render -> onInit loops until "Maximum update depth exceeded"
							if (this.state.pickTime || timePickerOptions.length === 0) {
								return;
							}
							const firstAvailableTime = timePickerOptions.find((i) => i.value !== null);
							if (firstAvailableTime) {
								this.setState({ pickTime: firstAvailableTime.value });
								this.changeTime(firstAvailableTime.value, minDT);
							}
						}}
					/>
					<Spacer />
					<IonButton expand="block" color="primary" className="button-uppercase" onClick={() => dispatch(setCommonModal('deliveryTimeModalOpen', false))}>
						{__('Continue')}
					</IonButton>
				</Modal>
			</>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		cards: store.orders.cards || [],
		profile: store.profile.profile || {},
		clientSecret: store.orders.clientSecret,
		deliveryTimeModalOpen: store.common.deliveryTimeModalOpen,
		restaurants: store.restaurants.restaurants || [],
		loading: store.common.loading || 0,
		giftVoucherData: store.orders.giftVoucherData,
	};
};

export default connect(mapStateToProps)(withTranslation(Checkout));
